import { Component, Prop, h, Host } from '@stencil/core';
import { parseJsonProp } from '../../../../../utils/helpers/hydration';

/**
 * Related links component for SignNow brand content links
 *
 * @product signnow
 * @source relinking
 * @version 2.0.0
 * @category SignNow
 * @contentConfig Related links component for displaying related content links
 * @slot heading - {required}, <me-heading variant="2" tag=["h1", "h2", "h3", "h4", "h5", "h6", "div"]> - Main heading for related links section
 * @example
 *   <sn-related-links-type-1
 *     links='[{"href":"/how-to-sign-pdf","label":"How to sign a PDF online"},{"href":"/create-esignature","label":"Create electronic signature"},{"href":"/send-for-signing","label":"Send documents for signing"}]'
 *   >
 *     <me-heading slot="heading" variant="2" tag="h3">Get more for office signature feature</me-heading>
 *   </sn-related-links-type-1>
 */
@Component({
  tag: 'sn-related-links-type-1',
  styleUrl: 'index.scss',
  shadow: false,
})
export class SNRelatedLinksType1 {
  @Prop() colorMode: 'signnow' | 'inverted' = 'signnow';

  /**
   * List of related links
   * @content
   * @type {array}
   * @item.type {object}
   * @item.property {string} href - Link URL
   * @item.property {string} label - Link text
   * @item.required href
   * @item.required label
   * @minItems 1
   */
  @Prop({ mutable: true }) links?: any[] | string;

  componentWillLoad() {
    this.links = parseJsonProp(this.links, []);
  }

  render() {
    const links = Array.isArray(this.links) ? this.links : [];
    if (!links.length) return <Host data-color-mode={this.colorMode}></Host>;

    return (
      <Host data-color-mode={this.colorMode}>
        <me-section yGap="2xl" yGapLg="5xl" role="region" aria-label="Related Links">
          <header class="related-links-type-1__header">
            <slot name="heading"></slot>
          </header>
          <ul class="related-links-type-1__tags-list" itemScope itemType="https://schema.org/ItemList">
            {links.map((link, index) => (
              <li class="related-links-type-1__tags-list-li">
                <a href={link.href} class="related-links-type-1__tags-list-item" itemScope itemType="https://schema.org/ListItem" itemProp="itemListElement">
                  <me-icon name="arrows--chevron-right" class="related-links-type-1__link-icon"></me-icon>
                  <span class="related-links-type-1__link-text" itemProp="name">
                    {link.label}
                  </span>
                  <meta itemProp="position" content={String(index + 1)} />
                </a>
              </li>
            ))}
          </ul>
        </me-section>
      </Host>
    );
  }
}
